import React, { useMemo, useState, useCallback, useEffect } from "react";
import "./index.less";
import { MessageSendType } from "@/types/chat/enum";
import classNames from "classnames";
import { Modal } from "antd";
import { WithTranslation, useTranslation } from "react-i18next";
import ImService from "@/server/ImService";
import { connect } from "dva";
import { mattchEmoji } from "@/components/chat/message/Input/Emoji";
import { convertStringToEmoji } from "@/components/chat/utils/ddemoji";
import { stringEncode } from "@/utils/chat/index";
import {
  getChatMessageNode,
  getHeadPortrait,
  getShowTime,
  TimeTransform
} from "@/components/chat/utils/commonMessageModal";
import { changeEgovUrl } from "@/utils/tools";
import bus from "@/utils/bus";
import ChatState from "@/types/chat/State";
import { isShowAlias, removeFirstOccurrence } from "@/utils/chat/message";
import ComGroupAlias from "@/baseComponents/ComGroupAlias";
import AIForwardMsgSummery from "@/baseComponents/Chat/AIForwardMsgSummery";
import Context from "@/components/chat/context";
import { addXtoken } from "@/utils/addToken";
interface IProps {
  message: any;
  sendType: MessageSendType;
  isMergeForward?: boolean;
}
type MergeForwardProps = Readonly<IProps & WithTranslation & ChatState>;
// let count = 0;
let flag = false;
function MergeForward(props: MergeForwardProps) {
  const { message, sendType, selectedSession, isMergeForward } = props;
  const { t } = useTranslation("chat");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalMessages, setModalMessages] = useState([] as any[]);
  const [isSameSession, setIsSameSession] = useState(false);
  const { isLLMAI } = React.useContext(Context);
  useEffect(() => {
    if (!message.data || !message.data[0] || !message.data[0].title) {
      return;
    }
    const fromSessionId = message.data[0].title.fromSessionId;
    const isSame = fromSessionId === selectedSession.sessionId;
    setIsSameSession(isSame);
  }, [message, selectedSession]);
  const handleOk = (e: any) => {
    e.stopPropagation();
    if (flag) {
      return;
    }
    flag = true;
    setIsModalVisible(false);
    // count--;
    setTimeout(() => {
      flag = false;
    }, 500);
  };

  const handleCancel = (e: any) => {
    e.stopPropagation();
    if (flag) {
      return;
    }
    flag = true;
    setIsModalVisible(false);
    // count--;
    setTimeout(() => {
      flag = false;
    }, 500);
  };

  const getClass = useCallback(() => {
    return classNames({
      message: true,
      "mergeForward-message": true,
      owner: sendType === MessageSendType.OWNER
    });
  }, [sendType]);
  let needData = useMemo(() => {
    return message.data[0].detail || [];
  }, [message]);
  let employees: string[] = useMemo(() => {
    let allEmployee: any = new Set(needData.map((item: any) => item.realname));
    return [...allEmployee].filter((item) => item !== message.data[0].title.toRealname);
  }, [needData, message]);

  const showRecordModal = async (e: any) => {
    e.stopPropagation();
    if (flag) {
      return;
    }
    flag = true;
    // if (count >= 3) {
    //     return;
    // }
    const imService = ImService.getInstance();
    const result: any = await imService.getMergeForwardBody(
      changeEgovUrl(message.data[0].content),
      message.id
    );
    if (result?.messages) {
      const dealMsgs = result?.messages.map((m: any) => {
        const newData = {
          ...m,
          sessionId: selectedSession.sessionId,
          sessionType: selectedSession.sessionType,
          from: message.from
        };
        if (selectedSession.isSingle) {
          newData.to = message.to;
        }
        return newData;
      });
      setModalMessages(dealMsgs);
      setIsModalVisible(true);
      // count++;
    } else {
      setIsModalVisible(false);
    }
    const nodes = document.querySelectorAll(".ant-modal-mask:not(.ant-modal-mask-hidden)");
    if (nodes && nodes.length > 0) {
      nodes.forEach((node, index) => {
        if (index === 0) {
          (node as HTMLElement).style.backgroundColor = "rgba(0, 0, 0, 0.45)";
        } else {
          (node as HTMLElement).style.backgroundColor = "inherit";
        }
      });
    }
    setTimeout(() => {
      flag = false;
    }, 500);
  };

  // dom
  const getHead = () => {
    if (!message.data || !message.data[0] || !message.data[0].title) {
      return "";
    }
    let realName = message.data[0].title.fromRealname || message.nickName || message.realname;
    if (message.data[0].title.mergeKind === "group") {
      let fromGroupName = message.data[0].title.fromGroupName;
      if (fromGroupName) {
        return <div className="head">{t("more_communicate_record", { fromGroupName })}</div>;
      } else {
        return <div className="head">{t("group_communicate_record")}</div>;
      }
    }
    if (realName !== message.data[0].title.toRealname) {
      return (
        <div className="head">
          {t("double_communicate_record", {
            realName,
            toRealname: message.data[0].title.toRealname
          })}
        </div>
      );
    } else {
      return <div className="head">{t("single_communicate_record", { realName })}</div>;
    }
  };

  const visibleChange = (e: MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    bus.emit("message-item-chatitem", false);
  };

  function getRealContent (content: string) {
    if (content.includes(t("quill-old-version-tip"))) {
      content = removeFirstOccurrence(content, t("quill-old-version-tip"));
    }
    return content;
  }

  useEffect(() => {
    if (isModalVisible) {
      document.addEventListener("contextmenu", visibleChange);
      return () => {
        document.removeEventListener("contextmenu", visibleChange);
      };
    }
  }, [isModalVisible]);

  const getModal = () => {
    if (!modalMessages.length) {
      return null;
    }
    let timeSection = "";
    if (modalMessages.length === 1) {
      timeSection = TimeTransform(modalMessages[0].timestamp);
    } else {
      let start = TimeTransform(modalMessages[0].timestamp);
      let end = TimeTransform(modalMessages[modalMessages.length - 1].timestamp);
      if (start !== end) {
        timeSection = start + " ~ " + end;
      } else {
        timeSection = start;
      }
    }

    return (
      <Modal
        title={getHead()}
        visible={isModalVisible}
        onOk={(e) => handleOk(e)}
        onCancel={(e) => handleCancel(e)}
        footer={null}
        zIndex={100}
        centered
        className="forwardModal"
        width={550}
        destroyOnClose={true}
      >
        {!isMergeForward && isLLMAI ? (
          <AIForwardMsgSummery message={message} detail={true} />
        ) : null}
        <div className="title">{timeSection}</div>
        <div className="forward-lists">
          {modalMessages.map((message: any, index: number) => {
            return (
              <div key={index} className="wrapper">
                <div className="forward-list">
                  <div className="left">{getHeadPortrait(message)}</div>
                  <div className="right">
                    <div className="name">
                      <div className="name_alias">
                        <span className="ellipsis">{message.senderName || message.realname}</span>
                        <ComGroupAlias
                          user={{
                            app: message.senderApp,
                            userId: message.sender,
                            teamId: message.senderTeamId
                          }}
                          session={selectedSession}
                        />
                      </div>
                      <div>{getShowTime(message)}</div>
                    </div>

                    <div className="message-box">
                      <div className="content-row">
                        <div className="content-col">
                          {getChatMessageNode(modalMessages, message, true, props.message)}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="line" />
              </div>
            );
          })}
        </div>
      </Modal>
    );
  };
  return (
    <div className="content">
      <div className={getClass()} onClick={(e) => showRecordModal(e)}>
        {getHead()}
        <div className="body">
          {needData.map((item: any, index: number) => {
            if (index > 3) {
              return null;
            }
            return (
              <div key={index} className="list">
                {item.content === "[聊天记录]" ? (
                  (item.realname || item.senderName) + "：[沟通记录]"
                ) : (
                  <>
                    <div className="list-name-alias">
                      <span className="ellipsis">{item.realname || item.senderName}</span>
                      <ComGroupAlias
                        user={{
                          app: item.senderApp,
                          userId: item.sender,
                          teamId: item.senderTeamId
                        }}
                        session={selectedSession}
                      />
                    </div>
                    <div
                      className="dangerous-merge-html"
                      dangerouslySetInnerHTML={{
                        __html: mattchEmoji(
                          convertStringToEmoji(
                            stringEncode(
                              `：${
                                isShowAlias(selectedSession) && item.atContent
                                  ? getRealContent(item.atContent)
                                  : getRealContent(item.content)
                              }`
                            )
                          )
                        )
                      }}
                    />
                  </>
                )}
              </div>
            );
          })}
        </div>
        {!isMergeForward && isLLMAI ? <AIForwardMsgSummery message={message} /> : null}
      </div>

      {getModal()}
    </div>
  );
}

function mapStateToProps({ chat }: any) {
  const { selectedSession } = chat as ChatState;
  return { selectedSession };
}

function mapDispatchToProps(dispatch: any) {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(MergeForward);
